import React from 'react'

export const CategoryBoxSettings = props => {
  return (
    <div className="empty-message">
      <p>No options available</p>
    </div>
  )
}
